import React, { useState } from 'react';
import { Document } from '../../../graphql/graphql';
import FormattedMomentDate, {
	DateFormat,
} from '../../Base/Components/FormattedMomentDate/FormattedMomentDate';
import Button from '../../../Components/Button/Button';
import { Theme } from '../../../Enums/Theme.enum';
import AntivirusCheck from '../../../Components/Base/Loading/AntivirusCheck';
import MediaViewerModal from '../../../Components/MediaViewer/MediaViewerModal';
import { prepareDocumentationFileForMediaViewer } from '../../Ecard/Services/eCardFile.service';
import { useAppContext } from '../../../Services/AppContext';

// @ts-ignore
import styles from './MedicalReportsListItem.module.scss';
import FileSignedBadge from '../../Base/Components/FileSignedBadge/FileSignedBadge';
import LinkButton from '../../../Components/Button/LinkButton';

interface Props {
	item: Document;
	onRefresh: () => void;
}

const MedicalReportsListItem: React.FC<Props> = ({ item, onRefresh }) => {
	const [isPreviewOpen, setIsPreviewOpen] = useState(false);
	const { socketUrl } = useAppContext();

	const handleCloseFile = (reload?: boolean) => {
		setIsPreviewOpen(false);
		if (reload) {
			onRefresh();
		}
	};

	return (
		<div className={styles.item}>
			<div className={styles.date}>
				<FormattedMomentDate
					date={item.createdAt}
					format={DateFormat.DATE_TIME}
				/>
			</div>
			<div className={styles.content}>
				<div className={styles.title}>{item.title?.extra?.text}</div>
			</div>
			<div className={styles.controls}>
				{item.documentationFile?.file?.signed && <FileSignedBadge />}
				{item?.file?.avResultText === 'clean' ? (
					<LinkButton
						onClick={() => setIsPreviewOpen(true)}
						title='base.show'
						theme={Theme.BLUE}
						firstUpper
					/>
				) : (
					<div>
						<AntivirusCheck inRow={true} />
					</div>
				)}
			</div>
			{isPreviewOpen && item.documentationFile && (
				<MediaViewerModal
					opened
					onClose={handleCloseFile}
					isSignable={item.documentationFile.canBeSigned || false}
					file={prepareDocumentationFileForMediaViewer(
						item.documentationFile,
						socketUrl,
					)}
				/>
			)}
		</div>
	);
};

export default MedicalReportsListItem;
